import { createClient, type SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string || 'https://jfxvmayhlfyzznmtebjo.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string

// Prevent multiple GoTrueClient instances during HMR or multiple bundles
const globalForSupabase = globalThis as unknown as { __nzr_supabase?: SupabaseClient }
export const supabase =
  globalForSupabase.__nzr_supabase ||
  (globalForSupabase.__nzr_supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // Use a unique storage key to avoid collisions with other Supabase clients in the browser
      storageKey: 'nzrail-elab-auth',
    },
  }))

// User roles type
export type UserRole = 'employee_lab' | 'nzrail_accounts' | 'insurer' | 'ali' | null

// Fetch current user role
export async function getCurrentRole(): Promise<UserRole> {
  try {
    const { data, error } = await supabase.rpc('current_role')
    if (error) {
      console.error('Error fetching role:', error)
      return null
    }
    return data as UserRole
  } catch (err) {
    console.error('Error in getCurrentRole:', err)
    return null
  }
}
